<template>
  <div>
    <TheExercises ref="exercises" section-slug="basics" topic-slug="articles" />
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

import TheExercises from '@/components/Hub/Exercises/TheExercises.vue'

export default {
  name: 'TestPage',

  components: {
    TheExercises
  },

  computed: {
    topic() {
      return {
        name: 'Articles',
        slug: 'articles',
        exercises: [
          {
            text: 'That is ___ odd dog habit.',
            answers: ['an'],
            possibleAnswers: [['a', 'an']],
            isHighQuality: true
          },
          {
            text: 'Can you pass me ___ salt, please?',
            answers: ['the'],
            possibleAnswers: [['a', 'an', 'the']],
            isHighQuality: true
          },
          {
            text: '___ cat rules this house.',
            answers: ['the'],
            possibleAnswers: [['a', 'an', 'the']],
            isHighQuality: true
          },
          {
            text: 'We saw ___ movie last night.',
            answers: ['a'],
            possibleAnswers: [['a', 'an', 'the']],
            isHighQuality: true
          },
          {
            text: '___ apple fell from that tree!',
            answers: ['an'],
            possibleAnswers: [['a', 'an', 'the']],
            isHighQuality: true
          }
        ]
      }
    }
  },

  created() {
    this.setTopicsSelected(this.topic)
    this.setExercisesList(this.topic.exercises)
  },

  mounted() {
    // const historyItem = {
    //   exercise: structuredClone(this.topic.exercises[0]),
    //   answer: 'a',
    //   isCorrect: false,
    //   explanation: null
    // }
    // this.addToHistory(historyItem)
    // this.$refs.exercises.setActiveIndex(0)
    // setTimeout(() => {
    //   this.$refs.exercises.isPostAnswer = true
    // }, 5000)
  },

  methods: {
    ...mapMutations('exercises', {
      addToHistory: 'ADD_TO_HISTORY'
    }),
    ...mapMutations('topics', {
      setTopicsSelected: 'SET_SELECTED'
    }),
    ...mapMutations('exercises', {
      setExercisesList: 'SET_LIST'
    })
  }
}
</script>
